import { z } from 'zod';
export const mailInboxQuerySchema = z.object({
    project_id: z.string().uuid(),
    smtp_account_id: z.string().uuid().optional(),
    brevo_only: z
        .enum(['true', 'false'])
        .optional()
        .transform((v) => v === 'true'),
    direction: z.enum(['inbound', 'outbound', 'all']).default('all'),
    folder: z.enum(['inbox', 'sent', 'archived', 'drafts', 'all']).default('inbox'),
    unmatched_only: z
        .enum(['true', 'false'])
        .optional()
        .transform((v) => v === 'true'),
    linked_only: z
        .enum(['true', 'false'])
        .optional()
        .transform((v) => v === 'true'),
    q: z.string().max(200).optional(),
    page: z.coerce.number().int().min(1).default(1),
    page_size: z.coerce.number().int().min(1).max(100).default(30),
});
export const mailMessagePatchSchema = z.object({
    lead_id: z.string().uuid().optional().nullable(),
    is_read: z.boolean().optional(),
    archive: z.boolean().optional(),
    subject: z.string().max(998).optional(),
    body_text: z.string().max(100_000).optional(),
});
export const mailMessageBulkSchema = z.object({
    project_id: z.string().uuid(),
    message_ids: z.array(z.string().uuid()).min(1).max(100),
    is_read: z.boolean().optional(),
    archive: z.boolean().optional(),
});
export const mailPreferencesSchema = z.object({
    project_id: z.string().uuid(),
    default_smtp_account_id: z.string().uuid().nullable(),
});
export const mailSendTestSchema = z.object({
    smtp_account_id: z.string().uuid(),
    project_id: z.string().uuid(),
    /** Default: ingelogde gebruiker. Optioneel ander adres (max 1). */
    to: z.string().email().optional(),
});
export const deliverabilityQuerySchema = z.object({
    project_id: z.string().uuid(),
});
export const mailSendPrecheckQuerySchema = z.object({
    lead_id: z.string().uuid(),
    smtp_account_id: z.string().uuid().optional(),
});
//# sourceMappingURL=mailMessages.js.map